<template>
    <div class="container-main">
        <div class="container-main-header-button">
            <v-btn depressed @click="back">
                <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <span>Редактирование блока</span>
        </div>

        <div class="container-block">
            <div>
                <v-select label="Вид блока" v-model="block" :items="blocks" item-value="key" item-text="name" return-object
                    outlined>
                    <template v-slot:selection="{ item }">
                        <v-img max-width="40px" :src="item.icon"></v-img>
                        <div style="margin-left: 20px"> {{ item.name }}</div>

                    </template>
                    <template v-slot:item="{ item }">
                        <v-img max-width="40px" :src="item.icon"></v-img>
                        <div style="margin-left: 20px"> {{ item.name }}</div>

                    </template>
                </v-select>

            </div>
        </div>
        <v-form ref="formFirst">
            <div v-if="block && block.fields.length > 0" class="container-block">
                <div class="container-block-title">
                    Содержание блока
                </div>
                <div v-if="block && checkFields('title')">
                    <div>
                        <v-text-field label="Заголовок" outlined v-model="newBlock.title">

                        </v-text-field>

                    </div>
                </div>
                <div v-if="block && checkFields('subtitle')">
                    <div>
                        <v-text-field label="Подзаголовок" outlined v-model="newBlock.subtitle">

                        </v-text-field>
                    </div>
                </div>
                <div v-if="block && checkFields('text')">
                    <div>
                        <v-textarea label="Текст" outlined required no-resize :rules="rules" rows="4"
                            v-model="newBlock.text">
                        </v-textarea>

                    </div>
                </div>
                <div v-if="block && checkFields('color')">
                    <div>
                        <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition"
                            offset-y max-width="290px" min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field label="Цвет" outlined v-on="on" v-model="newColor">

                                </v-text-field>

                            </template>
                            <v-color-picker v-model="newColor" no-title mode="hexa"></v-color-picker>

                        </v-menu>


                    </div>
                </div>
            </div>
        </v-form>


        <div v-if="block && checkFields('transition')" class="container-block">
            <div class="container-block-title">
                Вид перехода
            </div>
            <v-radio-group mandatory v-model="transitionType" row>

                <v-radio color="var(--app-dark-blue-1)" label="Ссылка" value="url"></v-radio>
                <v-radio color="var(--app-dark-blue-1)" label="Файл" value="file"></v-radio>
                <v-radio color="var(--app-dark-blue-1)" label="Страница" value="page"></v-radio>
                <v-radio color="var(--app-dark-blue-1)" label="Внутренний раздел" value="deeplink"></v-radio>
            </v-radio-group>
            <div v-if="transitionType == 'url'">
                <v-form lazy-validation ref="formLink">

                    <v-text-field label="Ссылка" required outlined v-model="newBlock.transition.path" :rules="[
                        v => !!v || 'Обязательно к заполнению',
                        v => checkValidUrl(v) || '',
                    ]"></v-text-field>
                    <v-checkbox class="container-main-checkbox pt-5" color="var(--app-dark-blue-1)"
                        v-model="newBlock.transition.isWebView"
                        label="Открыть WebView (ссылка откроется внутри приложения)"></v-checkbox>


                </v-form>
            </div>
            <div v-if="transitionType == 'page'">
                <v-form lazy-validation ref="formDeepLink">


                    <v-select :items="pages" v-model="newBlock.transition.path" outlined item-text="title" item-value="id"
                        :rules="[v => !!(v && v.length) || 'Обязательно к заполнению']"
                        label="Выберите страницу"></v-select>

                </v-form>
            </div>
            <div v-if="transitionType == 'deeplink'">
                <v-form lazy-validation>
                    <v-select :items="sections" outlined item-text="name" item-value="key"
                        :rules="[v => !!(v && v.length) || 'Обязательно к заполнению']"
                        v-model="newBlock.transition.appSectionKey" label="Выберите раздел для перехода"></v-select>

                </v-form>
            </div>

            <div v-if="transitionType == 'file'">
                <v-form lazy-validation ref="formPDF">

                    <div v-if="file" class="d-flex align-center">
                        <a target="_blank" :href="newBlock.transition.path">файл</a>
                        <v-icon color="var(--app-red-1)" style="margin-left:8px" @click="file = null"> mdi-delete-outline
                        </v-icon>

                    </div>

                    <v-file-input v-else outlined show-size v-model="newBlock.transition.file" label="Прикрепите файл pdf"
                        :rules="[value => (value && value.size < 104857600) || 'Размер pdf не больше 100 мб']"
                        hint="Максимальный размер pdf 100 Мб" persistent-hint
                        accept="application/pdf,application/vnd.ms-excel">

                    </v-file-input>

                </v-form>
            </div>

        </div>

        <div v-if="block && checkFields('files')" class="container-block">
            <div class="container-block-title">
                Вложенный файлы
            </div>

            <div class="d-flex justify-space-between" v-for="item in files" :key="item.id">
                <div style="width: 47%">
                    <v-text-field label="Название" required type="text" outlined v-model="item.name"></v-text-field>
                </div>
                <div class="container-block-file-preview" v-if="typeof item.file == 'string'">
                    <v-icon> mdi-file-pdf-box </v-icon>
                    <a style="margin-left:8px" target="_blank" :href="item.file">{{ item.name }}</a>
                    <v-icon color="var(--app-red-1)" style="margin-left:8px" @click="item.file = null"> mdi-delete-outline
                    </v-icon>

                </div>
                <div style="width: 47%" v-else>
                    <v-file-input outlined v-model="item.file" label="Прикрепите файл pdf"
                        :rules="[value => (value && value.size < 104857600) || 'Весом до 100 мб.']"
                        accept="application/pdf,application/vnd.ms-excel"></v-file-input>

                </div>

            </div>

            <div class="container-block-gallery-button">
                <span @click="addFile">Добавить файл</span>
            </div>


        </div>




        <div v-if="block && checkFields('image')" class="container-block">
            <div class="container-block-title">
                Изображение
            </div>

            <v-file-input accept="image/*" v-if="typeof newImage != 'string'" outlined
                :rules="[value => (value && value.size < 104857600) || 'Размер изображения не больше 100 мб']"
                hint="Максимальный размер изображения 100 мб" persistent-hint v-model="newImage" @change="previewImage"
                label="Прикрепить изображение"></v-file-input>
            <div v-if="typeof newImage != 'string'" class="container-block-gallery-button">
                Выбрать изображение из галереи
            </div>
            <div v-else class="d-flex align-center">
                <div>
                    <v-img :src="newImage" width="100px" style="margin-right: 20px">

                    </v-img>
                </div>

                <v-btn @click="newImage = null" style="width: auto !important" class="button-accept">Изменить</v-btn>
            </div>


        </div>



        <div v-if="block" class="container-block-footer-buttons">
            <div>
                <v-btn @click="saveBlock" style="width: auto !important" class="button-accept">
                    Сохранить
                </v-btn>

            </div>
            <div>
                <v-btn @click="dialogDelete = true" style="width: auto !important" class="button-accept-outlined" outlined
                    color="var(--app-red-1)">
                    Удалить
                </v-btn>

            </div>

        </div>
        <v-dialog width="600px" height="auto" persistent v-model="dialogDelete">
            <v-card>
                <v-card-title class="dialog-title">
                    <span class="title">Точно хотите удалить блок?</span>
                    <v-icon @click="dialogDelete = false;">mdi-close</v-icon>
                </v-card-title>
                <v-card-actions class="dialog-buttons">
                    <v-btn @click="dialogDelete = false;" style="width: 120px" outlined color="var(--app-green-1)">
                        Нет
                    </v-btn>
                    <v-btn @click="deleteBlock" style="width: 120px" outlined color="var(--app-red-1)">
                        Да
                    </v-btn>

                </v-card-actions>
            </v-card>
        </v-dialog>


    </div>
</template>
<script>



export default {

    data: () => ({
        block: '',
        dialogDelete: false,
        errImages: false,
        menu1: false,
        newColor: '',
        blocks: [],
        pages: [],
        sections: [],
        files: [],
        newBlock: {},
        transitionType: '',
        file: null,

        rules: [value => !!value || 'Обязательно к заполнению'],
        newImage: null,
        imgSrc: '',

    }),


    methods: {
        deleteBlock() {
            this.$axios.delete(this.$store.getters.apiAdminPanelV2 + '/page/block', {
                headers: {
                    'authorization': this.$store.getters.adminPanelHeaderAuth
                },
                params: {
                    blockId: this.$route.params.idBlock
                }
            })
                .then(() => {

                    this.dialogDelete = false
                    this.$router.push({ name: 'PageConstructor', params: { id: this.$route.params.id } })

                })
                .catch(err => {
                    this.$store.commit('errorSet', true)
                    this.$store.commit('errorTextSet', err)
                })
        },
        getAppSections() {

            this.$axios.post(this.$store.getters.apiAdminPanelV2 + '/appSection/list', {},
                {
                    headers: {
                        'authorization': this.$store.getters.adminPanelHeaderAuth
                    }
                })
                .then(res => {
                    this.sections = res.data.items.filter(i => {
                        if (!i.isRemovable) {
                            return i
                        }
                    })

                })
                .catch(err => {
                    this.$store.commit('errorSet', true)
                    this.$store.commit('errorTextSet', err)
                })

        },
        saveBlock() {
            const newArr = Array.from(this.files).filter(item => item.file)
            const newArrFiles = newArr.map(i => { return typeof i.file == 'object' ? i.file : null })
                .filter(el => { return el != null })
            const newArrNames = newArr.map(i => {
                if (typeof i.file == 'object') {
                    i.file = ''
                    return i
                }
                else {
                    return i
                }
            })
            let formData = new FormData();

            formData.append('type', this.block.key);
            formData.append('blockId', this.$route.params.idBlock);
            formData.append('pageId', this.$route.params.id);

            if (this.newBlock && this.newBlock.title) {
                formData.append('title', this.newBlock.title);
            }
            if (this.newBlock && this.newBlock.subtitle) {
                formData.append('subtitle', this.newBlock.subtitle);
            }
            if (this.newBlock && this.newBlock.text) {
                formData.append('text', this.newBlock.text);
            }
            if (this.newColor) {
                formData.append('color', this.newColor);
            }
            if (this.transitionType) {
                formData.append('transitionType', this.transitionType);
            }
            if (this.transitionType && this.transitionType == 'url') {
                formData.append('path', this.newBlock.transition.path);
                if (!this.newBlock.transition.isWebView) {
                    formData.append('isWebView', false);
                }
                else {
                    formData.append('isWebView', this.newBlock.transition.isWebView);
                }
            }
            if (this.transitionType && this.transitionType == 'page') {
                formData.append('path', this.newBlock.transition.path);
            }
            if (this.transitionType && this.transitionType == 'deeplink') {
                formData.append('appSectionKey', this.newBlock.transition.appSectionKey);
            }
            if (this.transitionType && this.transitionType == 'file') {
                formData.append('file', this.newBlock.transition.file);
            }
            for (let index = 0; index < newArrFiles.length; index++) {
                const element = newArrFiles[index];
                formData.append('files', element);
            }
            if (newArrNames.length > 0) {
                formData.append('files', JSON.stringify(newArrNames))
            }

            if (this.newImage) {
                formData.append('originalImage', this.newImage);
            }


            this.$axios.post(this.$store.getters.apiAdminPanelV2 + '/page/block', formData, {
                headers: {
                    'authorization': this.$store.getters.adminPanelHeaderAuth
                }
            })
                .then(() => {
                    this.$router.push({ name: 'PageConstructor', params: { id: this.$route.params.id } })


                })
                .catch(err => {
                    this.$store.commit('errorSet', true)
                    this.$store.commit('errorTextSet', err)
                })
        },
        getPages() {
            this.$axios.post(this.$store.getters.apiAdminPanelV2 + '/page/list', {


            }, {
                headers: {
                    'authorization': this.$store.getters.adminPanelHeaderAuth
                }
            })
                .then(res => {
                    const newArr = res.data.items.filter(item => item.id != this.$route.params.id)
                    this.pages = newArr


                })
                .catch(err => {
                    this.$store.commit('errorSet', true)
                    this.$store.commit('errorTextSet', err)
                })

        },
        addFile() {

            const newObj = {
                name: '',
                file: null
            }
            this.files.push(newObj)
        },
        checkFields(type) {
            if (this.block && this.block.fields) {
                const newArr = this.block.fields.filter(item => item == type)
                if (newArr[0]) {
                    return true
                }
                else {
                    return false
                }
            }
            else {
                return false
            }
        },
        previewImage() {

            if (this.newImage) {

                this.imgSrc = URL.createObjectURL(this.newImage)
            }
            else {
                this.imgSrc = ''
            }
        },
        back() {
            this.$router.push({ name: 'PageConstructor', params: { id: this.$route.params.id } })
        },

        getTypeBlocks() {
            this.$axios.post(this.$store.getters.apiAdminPanelV2 + '/page/block/type/list', {},
                {
                    headers: {
                        'authorization': this.$store.getters.adminPanelHeaderAuth
                    }
                })
                .then(res => {

                    this.blocks = res.data.items
                    this.getBlock()

                })
                .catch(err => {
                    this.$store.commit('errorSet', true)
                    this.$store.commit('errorTextSet', err)
                })
        },


        getBlock() {
            this.$axios.get(this.$store.getters.apiAdminPanelV2 + '/page/block', {
                headers: {
                    'authorization': this.$store.getters.adminPanelHeaderAuth
                },
                params: {
                    blockId: this.$route.params.idBlock
                }
            })
                .then(res => {
                    const obj = this.blocks.filter(item => item.key == res.data.type)

                    this.block = obj[0]
                    this.newBlock = res.data
                    if (res.data.color) {
                        this.newColor = res.data.color
                    }
                    if (res.data.transition && res.data.transition.type) {
                        this.transitionType = res.data.transition.type
                    }
                    if (res.data.files && res.data.files.length > 0) {
                        for (let index = 0; index < res.data.files.length; index++) {
                            const element = res.data.files[index];
                            const newObj = {
                                name: element.name,
                                file: element.file

                            }
                            this.files.push(newObj)
                        }
                    }
                    else {
                        const newObj = {
                            name: '',
                            file: null,

                        }
                        this.files.push(newObj)
                    }
                    if (res.data.originalImage) {
                        this.newImage = res.data.originalImage
                    }
                    if (res.data.transition && res.data.transition.type == 'file') {
                        this.file = res.data.transition.path
                    }

                    // if(res.data.transition){
                    //     this.newBlock.isWebView = res.data.transition.isWebView
                    // }
                    // if(res.data.transition && res.data.transition.type == 'page'){
                    //     this.newBlock.path = res.data.page
                    // }


                })
                .catch(err => {
                    this.$store.commit('errorSet', true)
                    this.$store.commit('errorTextSet', err)
                })

        },










    },
    created() {
        this.getPages()
        this.getAppSections()
        this.getTypeBlocks()
    },

    watch: {

    }
}
</script>
<style lang="scss" scoped>
.container-main {
    box-sizing: border-box;

    padding: 40px !important;

    .container-main-header-button {
        display: flex;
        align-items: center;
        margin-bottom: 30px;

        span {
            font-size: 28px;
            font-weight: 400;
            margin-left: 16px;
        }
    }

    .container-block {
        width: 50%;
        margin-bottom: 20px;

        .container-block-title {
            font-size: 24px;
            font-weight: 600;
            margin-bottom: 16px;

        }

        .container-block-gallery-button {
            text-decoration: underline;
            color: #1064DD;
            font-size: 18px;
            font-weight: 400;
            cursor: pointer;
            padding-bottom: 20px;
        }

    }

    .container-block-footer-buttons {
        display: flex;
        justify-content: space-between;
        width: 50%;
        margin-top: 60px;
    }

}
</style>